<template>
  <div
    @mouseenter="hover = true"
    @mouseleave="hover = false"
    class="h-16 lg:h-24 2xl:h-32 grid grid-cols-12 place-content-center gap-x-4"
    :class="{
      'bg-gray-300 opacity-30 cursor-not-allowed': disabled,
      'odd:bg-indigo-100 odd:bg-opacity-50 hover:bg-indigo-200 cursor-pointer':
        !disabled,
    }"
  >
    <div
      class="col-span-2 md:col-span-1 text-pink-600 flex justify-center place-self-center"
    >
      <icon
        v-if="!disabled"
        name="eye"
      />
    </div>
    <div
      class="col-span-4 md:col-span-2 text-base justify-self-start place-self-center"
    >
      {{ closedAt }}
    </div>
    <div
      class="col-span-6 md:col-span-3 text-base justify-self-start place-self-center"
    >
      {{ startedAt }}&nbsp;-&nbsp;{{ endedAt }}
    </div>
    <div
      class="hidden md:block col-span-3 text-base justify-self-start place-self-center max-w-full"
    >
      <div v-if="referent != null">
        <p class="truncate">
          {{ referent.firstname }}
          <span class="uppercase">{{ referent.lastname }}</span>
        </p>
        <p class="truncate">
          {{ referent.role }}
        </p>
      </div>
    </div>
    <div
      class="hidden md:block col-span-3 text-sm md:line-clamp-2 pr-5 italic justify-self-start place-self-center"
    >
      <p class="break-all">
        {{ itemsLibelles }}
      </p>
    </div>
  </div>
</template>

<script>
import Icon from '../Icon';
import InfoBulleHover from '../InfoBulleHover.vue';

export default {
  props: {
    evaluation: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      hover: false,
    };
  },

  components: {
    InfoBulleHover,
    Icon,
  },
  computed: {
    referent() {
      return [
        ...(this.evaluation.admins || []),
        ...(this.evaluation.managers?.map((m) => m?.manager ?? {}) || []),
        ...(this.evaluation.guests || []),
      ][0];
    },
    data() {
      return this.evaluation.data;
    },
    evaluationItems() {
      return this.data.items;
    },
    templateType() {
      return this.data.type_temp || this.data.template;
    },
    itemsLibelles() {
      if (['multi1', 'ref_multi1'].includes(this.templateType)) {
        return this.generateLibellesTypeRefMulti1;
      }
      if (['multi2', 'ref_multi2'].includes(this.templateType)) {
        let data = JSON.parse(JSON.stringify(this.data));
        return data.items
          .map((item) => `${item.name} : ${item.refEval}`)
          .filter((item) => item)
          .join(', ');
      }
      if (['multi3', 'ref_multi3'].includes(this.templateType)) {
        return this.generateLibellesTypeRefMulti3;
      }
      if (['pro', 'ref_pro'].includes(this.templateType)) {
        var evaluation = JSON.parse(JSON.stringify(this.evaluationItems));
        return evaluation.activities
          .map((activity) => activity.libelle)
          .filter((item) => item)
          .join(', ');
      }

      if (['sco', 'ref_sco'].includes(this.templateType)) {
        var evaluation = JSON.parse(JSON.stringify(this.evaluationItems));
        return evaluation.modules
          .map((mod) => mod.display_name)
          .filter((item) => item)
          .join(', ');
      }

      if (this.templateType === 'ROME') {
        var evaluation = JSON.parse(JSON.stringify(this.evaluationItems));

        let savoirFaire = Object.keys(
          evaluation.competences_bases.savoir_faire
        ).concat(Object.keys(evaluation.competences_spe.savoir_faire));
        let savoirs = Object.keys(evaluation.competences_bases.savoirs).concat(
          Object.keys(evaluation.competences_spe.savoirs)
        );

        let allComp = savoirFaire.concat(savoirs);
        return allComp.join(', ');
      }
      var evaluation = JSON.parse(JSON.stringify(this.evaluationItems));
      return evaluation
        .splice(0, 5)
        .map((item) => item.libelle)
        .join(', ');
    },
    createdAt() {
      return new Date(this.evaluation.created_at).toLocaleDateString();
    },
    startedAt() {
      return new Date(
        this.evaluation.start_at.replace(/-/g, '/')
      ).toLocaleDateString();
    },
    endedAt() {
      return new Date(
        this.evaluation.end_at.replace(/-/g, '/')
      ).toLocaleDateString();
    },
    closedAt() {
      return new Date(this.evaluation.closed_at).toLocaleDateString();
    },

    generateLibellesTypeRefMulti1() {
      let data = JSON.parse(JSON.stringify(this.data));

      return data.items
        .map((item) => {
          const criterions = item.criterions
            .map((criterion, index) => {
              if (criterion === null) return null;
              return `${data.template[index].libelle}: ${criterion}`;
            })
            .filter((item) => item)
            .join(', ');

          return `${item.name} (${criterions})`;
        })
        .filter((item) => item)
        .join(', ');
    },

    generateLibellesTypeRefMulti3() {
      let data = JSON.parse(JSON.stringify(this.data));

      return data.items
        .filter((item) => item.criterions)
        .map((item, itemIndex) => {
          const criterions = item.criterions
            .map((criterion, criterionIndex) => {
              if (criterion === null) return null;
              return `${data.template[itemIndex][criterionIndex].libelle}: ${criterion}`;
            })
            .filter((item) => item)
            .join(', ');

          return `${item.name} (${criterions})`;
        })
        .filter((item) => item)
        .join(', ');
    },
  },
  methods: {
    //
  },
};
</script>

<style scoped></style>
